export default __webpack_public_path__ + "static/media/8.aadc0ec9.jpg";